import { createFileRoute } from '@tanstack/react-router'
import { JobFormView } from '@/components/job-form'

/** `?contact=<id>` preselects that client and pulls their address onto the job. */
export const Route = createFileRoute('/_app/jobs_/new')({
  validateSearch: (search: Record<string, unknown>) => ({
    contact: typeof search.contact === 'string' ? search.contact : undefined,
  }),
  component: function NewJob() {
    const { contact } = Route.useSearch()
    return <JobFormView initialContactId={contact} />
  },
})
